import { useDispatch } from "react-redux";
import { BreadcrumbSegment, BreadcrumbState, setBreadcrumbSegment, setBreadcrumbs } from "../redux/breadcrumb-slice";
import { BreadcrumbInfo } from "../types";
import { useSelector } from "react-redux";
import { AppState } from "../redux/store";

/**
 * Provides helpers for updating breadcrumb state within the global store.
 * @returns Tuple containing setters for the breadcrumb trail and the current segment.
 */
export function useBreadcrumbs() {
    const dispatch = useDispatch()
    
    const setCrumbs = (crumbs: BreadcrumbInfo[]) => {
        dispatch(setBreadcrumbs(crumbs))
    }

    const setSegment = (segments: BreadcrumbSegment) => {
        dispatch(setBreadcrumbSegment(segments))
    }

    return [setCrumbs, setSegment] as const;
}
